require("./media.scss");

export class MediaManager {
    removeContent = (el) => {
        if (!el)
            return;

        while (el.firstChild) el.removeChild(el.firstChild);
    };
    showLoading(container, value) {
        if (!container) { return; }
        if (value) {
            container.classList.toggle('is-loading',value);
        } else {
            window.setTimeout(() => {
                container.classList.toggle('is-loading',value);
            }, 700)
        }
    }

    insertVideo = (section, placeHolder, videoUrl) => {
        const loadingCircle = section.querySelector('[data-role="loading-circle"]');
        const video = document.createElement('video');

        this.showLoading(section, true);
        video.controls = false;
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;

        placeHolder.appendChild(video);

        if (Hls.isSupported()) {
            var hls = new Hls();
            hls.config.capLevelToPlayerSize = true;
            hls.loadSource(videoUrl);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play();
                this.showLoading(section, false);
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.addEventListener('loadedmetadata', () => {
                video.play();
                this.showLoading(section, false);
            });
        }
        else {
            video.src = videoUrl;
            this.showLoading(section, false);
        }

        
    };

    updateMedia = () => {
        this.isMobile = window.matchMedia("(max-width: 991px)").matches;
        document.querySelector('[data-role="display-flag"]').setAttribute('data-currentDisplay', this.isMobile);
        
        document.querySelectorAll('[data-role="media-section"]').forEach(section => {
            section.querySelectorAll('[data-role="media"]').forEach(media => {
                let type = media.getAttribute('data-type');
                let typeVisible = type === 'mobile' && this.isMobile || type === 'desktop' && !this.isMobile;
                if (typeVisible) {
                    let viewSetup = media.getAttribute('data-viewsetup');
                    if (viewSetup === "true")
                        return;

                    let videoUrl = media.getAttribute('data-videoUrl');
                    this.showLoading(section, true);
                    if (videoUrl) {
                        this.removeContent(media);
                        this.insertVideo(section, media, videoUrl);
                    }
                    else {
                        this.showLoading(section, false);
                    }
                        
                    media.setAttribute('data-viewsetup', "true");
                } else {
                    this.removeContent(media);
                    media.setAttribute('data-viewsetup', "false");
                }
            });
        });
    };

    onResize() {
        this.updateMedia();
    }
}